import { connect } from 'react-redux'
import { compose, withStateHandlers, withProps, withHandlers } from 'recompose'
import { withRouter } from 'react-router-dom'
import { updatePassword } from './actions'
import View from '../../ui/forget-password/ResetPassword'
import withErrorIfProps from '../../core/withErrorIfProps'

const withUpdatePassword = connect(null, { updatePassword })
const withTokenFromUrl = compose(
  withRouter,
  withProps(props => {
    return {
      token: props.match.params.token
    }
  }),
  withErrorIfProps(props => !props.token)
)
const withOutcomeState = withStateHandlers(
  {
    isResetSuccess: false,
    isResetFailed: false,
    errorMessage: null
  },
  {
    setOutcome: state => (isResetSuccess, errorMessage = '') => ({
      isResetSuccess: !!isResetSuccess,
      isResetFailed: !isResetSuccess,
      errorMessage: !isResetSuccess ? errorMessage : null
    })
  }
)

const withSubmitHandlers = withHandlers({
  submit: props => newPassword => {
    const { token, updatePassword, setOutcome } = props
    return updatePassword(token, newPassword).then(outcome => {
      const { error } = outcome
      if (error) {
        return setOutcome(false, error.message)
      }
      setOutcome(true)
    })
  }
})

const decorator = compose(
  withTokenFromUrl,
  withUpdatePassword,
  withOutcomeState,
  withSubmitHandlers
)

export default decorator(View)



// WEBPACK FOOTER //
// ./src/services/password-reset/ResetPassword.js